import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nickname"]
  static values  = { challengeUrl: String, createUrl: String }

  async register() {
    this.clearError()

    try {
      // Get creation options from server
      const challengeRes = await fetch(this.challengeUrlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrfToken },
        body: JSON.stringify({})
      })
      const options = await challengeRes.json()
      if (challengeRes.status === 401) { window.location.href = options.redirect_to; return }
      if (!challengeRes.ok) { this.showError(options.error || "Could not start registration."); return }

      // Prepare options for browser
      options.challenge = b64ToBuffer(options.challenge)
      options.user.id   = b64ToBuffer(options.user.id)
      if (options.excludeCredentials) {
        options.excludeCredentials = options.excludeCredentials.map(c => ({ ...c, id: b64ToBuffer(c.id) }))
      }

      // Prompt to create passkey
      const credential = await navigator.credentials.create({ publicKey: options })

      // Send to server
      const nickname = this.hasNicknameTarget ? this.nicknameTarget.value.trim() : ""
      const createRes = await fetch(this.createUrlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrfToken },
        body: JSON.stringify({ ...serializeCreate(credential), nickname })
      })
      const result = await createRes.json()
      if (createRes.ok) {
        window.location.href = result.redirect_to
      } else {
        this.showError(result.error || "Registration failed.")
      }
    } catch (err) {
      if (err.name !== "NotAllowedError") this.showError(err.message)
    }
  }

  showError(msg) {
    const el = document.getElementById("webauthn-error")
    el.textContent = msg
    el.classList.remove("hidden")
  }

  clearError() {
    document.getElementById("webauthn-error")?.classList.add("hidden")
  }

  get #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}

function b64ToBuffer(b64url) {
  const b64 = b64url.replace(/-/g, "+").replace(/_/g, "/")
  return Uint8Array.from(atob(b64), c => c.charCodeAt(0)).buffer
}

function bufferToB64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "")
}

function serializeCreate(credential) {
  return {
    type: credential.type,
    id: credential.id,
    rawId: bufferToB64(credential.rawId),
    response: {
      clientDataJSON:    bufferToB64(credential.response.clientDataJSON),
      attestationObject: bufferToB64(credential.response.attestationObject)
    }
  }
}
